import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgChn = function SvgChn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.333 10.333-2.939 2.045 1.037-3.427-2.853-2.163 3.58-.073 1.175-3.382L7.51 6.715l3.58.073-2.853 2.163 1.036 3.427-2.939-2.045Zm5.485-5.832-.923.245.572-.765-.518-.802.904.308.603-.74-.014.955.89.345-.912.281-.052.954-.55-.78Zm3.115 2.562-.406.864-.217-.93-.947-.118.817-.495-.18-.937.723.624.836-.46-.37.88.696.653-.952-.08Zm-.359 3.527-.866.4.43-.851-.649-.7.944.146.465-.833.152.942.937.185-.85.436.114.948-.677-.673Zm-2.756 2.578-.923.244.572-.764-.518-.802.904.308.603-.74-.014.954.89.345-.912.282-.052.953-.55-.78Z",
    fill: "#F2C500"
  }));
};

export default SvgChn;